module.exports = __webpack_public_path__ + "img/kz.263fd938.svg";